export const fcmNames = {
	storageSpace: 'rgs-fcm-state',
	subscriptionState: 'FCM_SUB_STATUS',
};

export const fcmSubStatuses = {
	permission: 'granted',
	subscription: 'Success',
};

export const PERSONAL_DMS_AGREEMENT_LINK = 'https://www.rgs.ru/about/soglasiya-lk-dms';
export const PERSONAL_AGREEMENT_LINK = 'https://www.rgs.ru/consent_pdn';
export const ADVERTISING_AGREEMENT_LINK = 'https://www.rgs.ru/comm';
